<template>
    <guest-invoices-setup-base-card v-if="reservation">
        <template v-slot:card-body>
            <b-row>
                <b-col>
                    <b>TOTAL CHARGES:</b>
                </b-col>
                <b-col class="text-right">
                    <span class="mr-1">{{ reservation.total }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b>PAID SUM:</b>
                </b-col>
                <b-col class="text-right">
                    <span class="mr-1">{{ reservation.paid }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b>REMAINING BALANCE:</b>
                </b-col>
                <b-col class="text-right">
                    <span class="mr-1">{{ reservation.balance_with_deposits }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b>STATUS:</b>
                </b-col>
                <b-col class="text-right">
                    <span class="mr-1">{{ reservation.state_string }}</span>
                </b-col>
            </b-row>
        </template>
    </guest-invoices-setup-base-card>
</template>

<script>
import { mapGetters } from 'vuex';
import GuestInvoicesSetupBaseCard from './base-card.vue';

export default {
    name: 'GuestInvoicesSetupThirdCard',
    components: { GuestInvoicesSetupBaseCard },
    computed: {
        ...mapGetters('guest', ['reservation']),
    },
};
</script>
